import { action } from 'easy-peasy';

export default {
    applicant: {
        FirstName: "",
        MiddleName: "",
        LastName: "",
        Suffix: "",
        Address1: "",
        Address2: "",
        City: "",
        State: "",
        Zip: "",
        Email: "",
        PrimaryPhone: "",
        SecondaryPhone: "",
        dob: "",
        SSN: "",
        MonthlyIncome: "",
        IncomeSource: "", 
        HasCheckingAccount: "", 
        cashIntent: "",
        ReservationCode: "",
        Resident: false,

        // Terms
        eSignConsent: false,
        creditProtection: "",
        tcAcknowledgement: "false",
        emailOptIn: true,
        cardColorCode: "",
        generalAcknowledgement: "",
        SMSConsent: false,

        // Additional Cardholder
        hasAdditionalCardholder: "",
        additionalCardholderFirstName: "",
        additionalCardholderMI: "",
        additionalCardholderLastName: "",
        additionalCardholderSuffix: "",

        // Spouse Information
        isMarried: "",
        spouseFirstName: "",
        spouseLastName: "",
        spouseMiddleInitial: "",
        spouseSuffix: "",
        spouseHasDifferentAddress: "",
        spouseAddress1: "",
        spouseAddress2: "",
        spouseCity: "",
        spouseState: "",
        spouseZip: "",
        spouseEmail: "",

        // Tracking
        sessionId: "",
        srcId: "",
        sid: "0",
        pubId: "",
        subId: "",
        hid: "0",
        c1: "",
        c2: "",
        c3: "",
        gclid: "",
        gAdsExpirationDate: "",
        fbclid: "",
        fbAdsExpirationDate: "",
        msclid: "",
        msAdsExpirationDate: "",

        // Site Settings
        webSite: "",
        engineID: "",
        isPrequal: "true",
        pid: "",
        ProductCode: "",
        productId: "",
        appRef: "",
        step: 1,
        termsId: "",
    },

    setApplicant: action((state, payload) => {
        state.applicant[payload.index] = payload.value;
    }),

    storeApplicantData: action((state, payload) => {
        state.applicant = { ...state["applicant"], ...payload };
    }),

    setCompleteApplicant: action((state, payload) => {
        state.applicant = payload;
    }),
}